import axios from 'axios';
const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_API,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

axiosClient.interceptors.request.use(function (config) {
    let token = localStorage.getItem('token');
    config.headers['Authorization'] = 'Bearer ' + token;
    return config;
});

export default axiosClient;
